import React from 'react'
import { Text } from '../../../../styles/reactnative'
import SettingChange from './SettingChange'
import EntryTime from '../../../components/PositionColumns/EntryTime'

export const columns = (mutate, usermodal) => {
	return [
		{
			title: 'IP',
			dataIndex: 'ip',
			key: 'ip',
			align: 'center',
			render: (text, record) => <Text>{text}</Text>,
		},
		{
			title: 'DATE',
			dataIndex: 'created_at',
			key: 'created_at',
			align: 'center',
			render: (text, record) => <EntryTime time={text} />,
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
			align: 'center',
			render: (text, record) => (
				<SettingChange data={record} mutate={mutate} />
			),
		},
	]
}
